'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/table/style/css');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _css2 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css3 = require('antd/lib/date-picker/style/css');

var _datePicker = require('antd/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _inout = require('../actions/inout');

var _utils = require('../utils');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RangePicker = _datePicker2.default.RangePicker;


var MaxDate = 90 * 24 * 60 * 60 * 1000;

var Inout = _react2.default.createClass({
    displayName: 'Inout',

    propTypes: {
        inouts: _react.PropTypes.object.isRequired,
        filter: _react.PropTypes.object.isRequired,
        dispatch: _react.PropTypes.func.isRequired
    },
    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (!(0, _utils.filterEqual)(nextProps.filter, this.props.filter)) {
            var dispatch = nextProps.dispatch,
                filter = nextProps.filter;

            dispatch((0, _inout.fetchInoutsIfNeeded)(filter));
        }
    },
    componentDidMount: function componentDidMount() {
        var _props = this.props,
            dispatch = _props.dispatch,
            filter = _props.filter;

        dispatch((0, _inout.fetchInoutsIfNeeded)(filter));
    },
    onChange: function onChange(date, dateString) {
        if (dateString[0] && dateString[0] !== '') {
            var timeStamp = [];
            timeStamp[0] = Date.parse(dateString[0] + ' 00:00:00');
            timeStamp[1] = Date.parse(dateString[1] + ' 23:59:59');
            if (timeStamp[1] - timeStamp[0] > MaxDate) {
                _message2.default.error('日期跨度超过限制，请选择跨度在90天内的日期');
                return;
            }
        }
        this.props.dispatch((0, _inout.filterInouts)({
            'date': dateString
        }));
    },
    render: function render() {
        var columns = [{
            title: '日期',
            key: 'date',
            dataIndex: 'date'
        }, {
            title: '收入',
            key: 'charge',
            dataIndex: 'charge'
        }, {
            title: '退款',
            key: 'refund',
            dataIndex: 'refund'
        }, {
            title: '返佣',
            key: 'return_referer',
            dataIndex: 'return_referer'
        }];

        var items = this.props.inouts.items;
        var tableConfig = {
            columns: columns,
            dataSource: items,
            showHeader: true,
            rowKey: function rowKey(record) {
                return record.id;
            }
        };
        var date = this.props.filter.date;

        return _react2.default.createElement(
            'div',
            { id: 'inout', className: 'clearfix' },
            _react2.default.createElement(
                'div',
                { className: 'filter' },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'span',
                        null,
                        '\u65E5\u671F\uFF1A'
                    ),
                    _react2.default.createElement(RangePicker, { onChange: this.onChange, allowClear: false, value: [(0, _moment2.default)(date[0]), (0, _moment2.default)(date[1])],
                        defaultValue: [(0, _moment2.default)(date[0]), (0, _moment2.default)(date[1])] })
                )
            ),
            _react2.default.createElement(_table2.default, tableConfig)
        );
    }
});

var mapStateToProps = function mapStateToProps(store) {
    var _store$inout = store.inout,
        inouts = _store$inout.inouts,
        filter = _store$inout.filter;

    return {
        inouts: inouts,
        filter: filter
    };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Inout);


//////////////////
// WEBPACK FOOTER
// ./src/js/containers/inout.js
// module id = 1321
// module chunks = 0